import cx from 'classnames';
import styles from './PrimaryTab.module.scss';

import { FC } from 'react';
import { Typography } from '../../Typography';
import { NavLink } from 'react-router-dom';
import { StarSvg } from '@assets/svg';

interface PrimaryTabProps {
  label: string;
  link: string;
  isActive?: boolean;
  hasReward?: boolean;
  dataTutorial?: string;
}

export const PrimaryTab: FC<PrimaryTabProps> = ({
  label,
  link,
  isActive = false,
  hasReward = false,
  dataTutorial,
}) => {
  const rewardVisible = hasReward && !isActive;

  return (
    <NavLink
      to={link}
      data-tutorial={dataTutorial}
      className={cx(
        styles.tabContainer,
        { [styles.selectedTab]: isActive },
        { [styles.reward]: rewardVisible },
      )}
    >
      <Typography
        component="h3"
        variant="secondary"
        textTransform="uppercase"
        className={isActive ? styles.selectedText : undefined}
      >
        {label}
      </Typography>

      {rewardVisible && (
        <>
          <StarSvg className={cx(styles.star, styles.topLeft)} />
          <StarSvg className={cx(styles.star, styles.topRight)} />
          <StarSvg className={cx(styles.star, styles.bottomLeft)} />
          <StarSvg className={cx(styles.star, styles.bottomRight)} />
        </>
      )}
    </NavLink>
  );
};
